/*
* Contact Map
*/

export const MAP_STYLE = [
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e9e9e9"
            },
            {
                "lightness": 17
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 17
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 29
            },
            {
                "weight": 0.2
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 18
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dedede"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#ffffff"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "saturation": 36
            },
            {
                "color": "#333333"
            },
            {
                "lightness": 40
            }
        ]
    },
    {
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f2f2f2"
            },
            {
                "lightness": 19
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#fefefe"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#fefefe"
            },
            {
                "lightness": 17
            },
            {
                "weight": 1.2
            }
        ]
    }
]

/* global google */

$.fn.ContactMap = function() {
  let self = this
  self.map = undefined
  self.marker = undefined

  return function() {
    self.map = new google.maps.Map(self.get(0), {
      styles: MAP_STYLE,
      disableDefaultUI: true,
      zoom: 14,
      scrollwheel: false,
      center: {
        lat: 45.5971898 + 0.00075,
        lng: -73.7567728 - 0.00075,
      },
    })

    self.marker = new google.maps.Marker({
      position: {
        lat: 45.5971898,
        lng: -73.7567728,
      },
      icon: {
        url: '/img/elements/marker.svg',
        size: new google.maps.Size(50, 62),
        scaledSize: new google.maps.Size(20, 25),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(9, 45),
      },
      map: self.map,
      url: "https://www.google.com/maps/place/Guy+Saint-Jean+Éditeur/@45.5971898,-73.7567728,17z/data=!3m1!4b1!4m5!3m4!1s0x4cc9214e87de9791:0xa6cecf56df640af9!8m2!3d45.597186!4d-73.7545948",
    })

    google.maps.event.addListener(self.marker, 'click', function() {
      window.open(this.url, '_blank')
    })
  return self
  }()
}
